import React from 'react'
import {ReactComponent as SearchIconSvg} from './searchIcon.svg';

const SearchIcon = () => (
  <div className="icon"><SearchIconSvg /></div>
)

export default SearchIcon;
